<template>
  <article ref="scrollBox" class="bus_list_wrap home CompareFlightIndex">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1)">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">{{from}} → {{to}}</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>

    <section class="pages_content">

      <div class="textalignM paySuccessDiv">
        <div class="paySuccessIconDiv">
          <i class="iconfont_new icon-ok paySuccess"></i>
        </div>
        <div class="paySuccessText">支付成功</div>
      </div>

      <div class="comfirm">
        <div class="hangbanBox">
          <div class="hangbanItem">
            <div class="flexItem1">
              <div class="flight-plane">
                <img :src="dataList.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
                {{dataList.airCompanyName}} {{dataList.flightNo}}
              </div>
            </div>

            <div class="flexContainer">
              <div class="flexItem3">
                <div class="flexContainer flight-info-wrap">
                  <div class="flexItem1 textalignR">
                    <div class="flight-timeSmall">{{dataList.depTime}}</div>
                    <div
                      class="flight-airport"
                    >{{dataList.depCityName+dataList.depAirportName+dataList.depTerminal}}</div>
                  </div>
                  <div class="icon-arrow"></div>
                  <div class="flexItem1">
                    <div class="flight-timeSmall">{{dataList.arrTime}}</div>
                    <div
                      class="flight-airport"
                    >{{dataList.arrCityName+dataList.arrAirportName+dataList.arrTerminal}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flexContainer">
              <div class="flexItem1 textalignR">
                <div class="flight-plane tag-advantage">
                  <span v-if="dataList.isHasMeal==1" style="margin-right:5px;">
                    <i class="iconfont_new icon-canyin flight-planeIcon"></i>&nbsp;有餐食
                  </span>
                  <span v-if="dataList.stopNum==0">
                    <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>&nbsp;直飞
                  </span>
                  <span v-else>
                    <i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
                    &nbsp;经停{{dataList.stopNum}}次
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hangbanBox" style="margin-top:0.25rem;">
          <div class="hangbanItem">
            <div class="flexContainer">
              <div style="margin-right:10px;">
                <i
                  class="iconfont_new icon-duihao radioDiv"
                  v-bind:class="{ radioDivCheck : need1 }"
                  style="margin-top:0;"
                ></i>
              </div>
              <div class="flexItem1 textalignR">
                <div class="color2">
                  <span class="miaoshaText">秒杀价</span>
                  是否需要机场专车
                  <i
                    class="iconfont_new icon-toubaoxuzhi"
                    style="color:red;"
                    @click.stop="showQuestion"
                  ></i>
                </div>
              </div>
            </div>

            <div
              v-if="need1"
              style="border-top: 1px solid #eaeaea;padding-top: 10px;margin-top:5px;"
            >
              <div class="flexContainer">
                <div class="flexItem3">
                  <div class="flexContainer flight-info-wrap">
                    <div class="flexItem1 textalignR">
                      <div class="flight-timeSmall">中山出发</div>
                      <div class="flight-airport">2002-05-01 15:00</div>
                    </div>
                    <div class="icon-arrow"></div>
                    <div class="flexItem1">
                      <div class="flight-timeSmall">广州机场</div>
                      <div class="flight-number" style="text-align: right;margin-top:0;">
                        <dfn>¥</dfn>
                        <strong>230</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hangbanBox" style="margin-top:0.25rem;">
          <div class="hangbanItem">
            <div class="flexContainer">
              <div style="margin-right:10px;">
                <i
                  class="iconfont_new icon-duihao radioDiv"
                  v-bind:class="{ radioDivCheck : need2 }"
                  style="margin-top:0;"
                ></i>
              </div>
              <div class="flexItem1 textalignR">
                <div class="color2">
                  <span class="miaoshaText">秒杀价</span>
                  是否需要接送
                  <i
                    class="iconfont_new icon-toubaoxuzhi"
                    style="color:red;"
                    @click.stop="showQuestion"
                  ></i>
                </div>
              </div>
            </div>

            <div
              v-if="need2"
              style="border-top: 1px solid #eaeaea;padding-top: 10px;margin-top:5px;"
            >
              <div class="flexContainer difangInput">
                <div>
                  <i class="iconfont_new icon-dingwei2"></i> 出发地：
                </div>
                <div class="flexItem1 textalignR">
                  <input
                    type="text"
                    class="noBorderInput"
                    style="text-align: right;"
                    v-model="chufadi"
                    disabled
                  />
                </div>
              </div>
              <div class="flexContainer difangInput">
                <div>
                  <i class="iconfont_new icon-dingwei2"></i> 目的地：
                </div>
                <div class="flexItem1 textalignR">
                  <input
                    type="text"
                    class="noBorderInput"
                    style="text-align: right;"
                    v-model="mudidi"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="personBox">
          <div class="flexContainer" style="padding:0 0 0.25rem 0;border-bottom:1px solid #eaeaea;">
            <div class="flexItem1">乘机人</div>
          </div>

          <div class="flexContainer personBoxItem" v-for="data in personList" :key="data.id">
            <div class="flexItem1">
              <i class="iconfont_new icon-icon- personIcon"></i>
              {{data.name}}
            </div>
            <div class="flexItem1 textalignR">
              <i class="iconfont_new icon-tel personTelIcon"></i>
              {{data.tel}}
            </div>
          </div>
        </div>

        <div class="rule">
          订单包含机票、附加选购产品、机场建设费、燃油费、税费。
          <br />点击“去支付”表示已经阅读并同意"航意航延组合险保险条款","锂电池及危险品须知","机票预订须知","活动价格说明","机票增值服务供应商资质"
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "OrderResult",
  data() {
    return {
      from: "北京",
      to: "南京",

      need1: true,
      need2: true,

      chufadi: "西区",
      mudidi: "广州南站",

      personList: [
        { id: 1, name: "张三", tel: "15113369754" },
        { id: 2, name: "李四", tel: "15113369754" },
      ],

      dataList: {
        id: 1,
        depTime: "2020-08-01 08:30",
        arrTime: "2020-08-01 11:30",
        flightNo: "C12344",
        airCompanyName: "南方航空",
        isHasMeal: 1,
        airCompanyLogoImg: "http://183.58.24.55/flight/logo/CZ.png",
        stopNum: 3,
        policyItem: {
          cabin: [{ ticketCount: "A" }],
        },
        policys: [
          {
            priceDatas: [
              {
                price: 1243,
              },
            ],
          },
        ],
      },
    };
  },
  components: {},
  mounted() {},
  methods: {
    showQuestion() {
      this.$Modal.warning({
        title: "提示",
        content: "1111111111",
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderResult.vue